module.exports = __webpack_public_path__ + "static/media/personas.d8c97e99.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/personas.pdf
// module id = 400
// module chunks = 1